export const buildDisclosureMessage = ({ choiceClause, scopeClause, capNode }) => (
  <span className="flex flex-col gap-2">
    <span>
      Our practice participates in a secure, card-brand compliant Healthcare Program for authorized
      healthcare payments. As part of your visit, you {choiceClause} securely tokenize your payment
      card. Tokenization replaces your card details with an encrypted token stored in our PCI- and
      HIPAA-compliant system. Your full card number is not stored or accessible by our practice.
    </span>
    <span>
      When authorized, your tokenized card may be used to refund overpayments or collect a remaining
      patient balance after insurance processing. Additional terms regarding invoicing, auto-charge
      and pre-authorization duration will be presented for your review and signature when a
      Pre-Authorized Healthcare Form is required. Your card on file will not be charged more than{' '}
      {capNode} for services rendered during this visit{scopeClause}.
    </span>
  </span>
);
